module.exports = __webpack_public_path__ + "static/img/4-11.e497064.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoology/4-11.png
// module id = 49gu
// module chunks = 15